import cx from 'classnames';

import { SkeletonCircle } from '../../../design-system/components/skeletons/SkeletonCircle';
import { SkeletonRatio } from '../../../design-system/components/skeletons/SkeletonRatio';
import { SkeletonRectangle } from '../../../design-system/components/skeletons/SkeletonRectangle';

import style from './ItineraryCardSkeleton.module.css';

export const ItineraryCardSkeleton = () => {
    return (
        <div className={cx(style.skeletonCard)}>
            <SkeletonRatio ratio={5 / 4} />
            <div className={cx(style.body)}>
                <div className={cx(style.skeletonRow)}>
                    <SkeletonCircle />
                    <SkeletonRectangle width="60%" height="16px" />
                </div>
                <SkeletonRectangle height="56px" />
                <SkeletonRectangle height="16px" width="70%" />
                <SkeletonRectangle height="48px" width="100%" />
            </div>
        </div>
    );
};
